import { useState } from 'react';
import { FeedbackState } from '../types';
import { FamlaServices } from '../../../../services';

export const useFeedback = (users: any) => {
    const [feedback, setFeedback] = useState<FeedbackState>({});

    const handleFeedbackClick = async (reportId: string, isPositive: boolean) => {
        if (feedback[reportId]?.submitted) return;

        if (isPositive) {
            setFeedback(prev => ({
                ...prev,
                [reportId]: {
                    showCommentInput: false,
                    comment: '',
                    isPositive: true,
                    submitted: false
                }
            }));

            try {
                const response = await FamlaServices(
                    "api_host",
                    `/report/thumbs/${reportId}`,
                    "PUT",
                    { up: true, comment: '' },
                    users.access_token
                );

                if (response.status === 200) {
                    setFeedback(prev => ({
                        ...prev,
                        [reportId]: {
                            ...prev[reportId],
                            submitted: true
                        }
                    }));
                }
            } catch (error) {
                setFeedback(prev => {
                    const newFeedback = { ...prev };
                    delete newFeedback[reportId];
                    return newFeedback;
                });
            }
        } else {
            setFeedback(prev => ({
                ...prev,
                [reportId]: {
                    showCommentInput: true,
                    comment: '',
                    isPositive: false,
                    submitted: false
                }
            }));
        }
    };

    const handleCommentSubmit = async (reportId: string) => {
        const feedbackData = feedback[reportId];
        if (feedbackData && feedbackData.comment.trim()) {
            try {
                const response = await FamlaServices(
                    "api_host",
                    `/report/thumbs/${reportId}`,
                    "PUT",
                    { up: false, comment: feedbackData.comment },
                    users.access_token
                );

                if (response.status === 200) {
                    setFeedback(prev => ({
                        ...prev,
                        [reportId]: {
                            ...prev[reportId],
                            submitted: true
                        }
                    }));
                }
            } catch (error) {
                console.error("Erreur lors de l'envoi du feedback négatif", error);
            }
        }
    };

    return {
        feedback,
        setFeedback,
        handleFeedbackClick,
        handleCommentSubmit
    };
};